import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete'
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';

import { BulletinListComponent } from './bulletin-list.component';

import { PaginationComponent } from '../../pagination/pagination.component';

@NgModule({
    declarations: [BulletinListComponent,
        PaginationComponent
    ]
    ,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        TableModule,
        MessageModule,
        MessagesModule,
        DropdownModule,
        InputTextModule,
        AutoCompleteModule,
        ButtonModule,
        DialogModule
    ]
})
export class BulletinListModule {

}